import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceDeleteEvidenceFieldSectionPathParameters } from 'api/actions/device-delete-evidence-field-section/device-delete-evidence-field-section-path-parameters';
import { DeviceDeleteEvidenceFieldSectionResponse } from 'api/actions/device-delete-evidence-field-section/device-delete-evidence-field-section-response';

type DeviceDeleteEvidenceFieldSectionQueryParameters = Record<string, any>;

/**
 * The path of the DeviceDeleteEvidenceFieldSection action.
 */
export const deviceDeleteEvidenceFieldSectionActionPath = new SweetPath<
  keyof DeviceDeleteEvidenceFieldSectionPathParameters
>('/api/device/evidence-field-sections/{sectionId}', { path: '{param}' });

/**
 * Creates a contextualized DeviceDeleteEvidenceFieldSection actions.
 */
export default function createDeviceDeleteEvidenceFieldSectionAction(axios: AxiosInstance) {
  return function deviceDeleteEvidenceFieldSectionAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceDeleteEvidenceFieldSectionPathParameters;
    query?: DeviceDeleteEvidenceFieldSectionQueryParameters;
  }) {
    const path = deviceDeleteEvidenceFieldSectionActionPath.insert(parameters);

    return axios.request<DeviceDeleteEvidenceFieldSectionResponse, DeviceDeleteEvidenceFieldSectionResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
